import React from "react";
import { Box, Button, TextField } from "@mui/material";
import { Formik } from "formik";
import * as yup from "yup";
// unused imports removed
import Header from "../../../components/Header";
import Swal from "sweetalert2";
import { generateAndExecuteMutation } from "../../../data/Axios/DynamicService";
import { setupManagementUrl } from "../../../config";
const base_url = setupManagementUrl.uri;
const UOMForm = (props) => {
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);

  const initialValues = {
    name: props.data ? props.data.name : "",
    unit: props.data ? props.data.unit : "",
  };

  const validationSchema = yup.object().shape({
    name: yup.string().required("name is required"),
    unit: yup.string().required("unit is required"),
  });

  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const mutationData = {
        name: values.name,
        unit: values.unit,
      };
      if (props.isEditing) {
        mutationData.id = props.data.id;
        mutationData.updatedBy = userId;
        mutationData.createdBy = props.data.createdBy;
      } else {
        mutationData.createdBy = userId;
      }
      const response = await generateAndExecuteMutation(
        props.isEditing ? "updateUnitofMeasure" : "createUnitOfMeasure",
        mutationData,
        "unitofmeasure",
        base_url
      );
      if (response) {
        props.onClose();
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: `Unit of measure ${
            props.isEditing ? "updated" : "created"
          } successfully.`,
        }).then(() => {
          props.refetchData(); // Close the modal after the success message
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "An error occurred while processing your request. Please try again later.",
      });
    }

    setSubmitting(false);
  };

  return (
    <Box
      m="20px"
      bgcolor="background.paper"
      p={3}
      //borderRadius={8}
      // boxShadow={3}
    >
      <Header
        title={
          props.isEditing ? "Edit unit of measure" : "Create unit of measure"
        }
        subtitle={
          props.isEditing
            ? "Edit an existing unit of measure"
            : "Create a new unit of measure"
        }
      />

      <Formik
        onSubmit={handleSubmit}
        initialValues={initialValues}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          touched,
          handleBlur,
          handleChange,
          handleSubmit,
          isSubmitting,
        }) => (
          <form onSubmit={handleSubmit}>
            <Box display="grid" gap="30px">
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Name *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.name}
                name="name"
                error={touched.name && !!errors.name}
                helperText={touched.name && errors.name}
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Unit *"
                onBlur={handleBlur}
                onChange={handleChange}
                value={values.unit}
                name="unit"
                error={touched.unit && !!errors.unit}
                helperText={touched.unit && errors.unit}
              />
              <Button
                type="submit"
                color="secondary"
                variant="contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Submitting..." : "Submit"}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  );
};

export default UOMForm;
